module.exports = __webpack_public_path__ + "dabc357973ddd768c56b16dffe900433.fbx";